import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SecondaryButtonStyleEnum } from '../../modals/base-action-modal/base-action-modal.component';
import { BaseModalComponent } from '../../../../models/base/base-modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileToJsonService } from '../../../remittance/services/file-to-json.service';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MembersTableColumnErrors } from './types/members-table-column-errors';
import { MembersFileRecord } from './interfaces/members-file-record';

@Component({
  selector: 'app-batch-add-members-file-preview-modal',
  templateUrl: './batch-add-members-file-preview-modal.component.html',
  styleUrls: ['./batch-add-members-file-preview-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class BatchAddMembersFilePreviewModalComponent extends BaseModalComponent {
  public ignoreEscape: boolean = false;

  constructor(protected activeModal: NgbActiveModal) {
    super(activeModal);
  }

  private fileToJsonService = inject(FileToJsonService);

  private _fileToPreview = new BehaviorSubject<File | null>(null);
  public fileToPreview$ = this._fileToPreview as Observable<File | null>;
  public setFileToPreview = (f: File) => this._fileToPreview.next(f);

  private _fileName = new BehaviorSubject<string>('');
  public fileName$ = this._fileName as Observable<string>;
  public setFileName = (name: string) => this._fileName.next(name);

  private _invalidRows = new BehaviorSubject<number[]>([]);
  public invalidRows$ = this._invalidRows as Observable<number[]>;
  public setInvalidRows = (rows: number[]) => this._invalidRows.next(rows);

  private _invalidColumns = new BehaviorSubject<MembersTableColumnErrors>({});
  public invalidColumns$ = this._invalidColumns as Observable<MembersTableColumnErrors>;
  public setInvalidColumns = (columns: MembersTableColumnErrors) => this._invalidColumns.next(columns);

  private _records = new BehaviorSubject<MembersFileRecord[]>([]);
  public records$ = this._records as Observable<MembersFileRecord[]>;

  public hasErrors$ = this.invalidRows$.pipe(map(rows => rows.length > 0));

  public primaryLabel$ = this.hasErrors$.pipe(
    map(hasErrors => {
      return hasErrors ? $localize`Discard Upload` : $localize`Continue`;
    })
  );

  private listenToFile = this.fileToPreview$.subscribeWhileAlive({
    owner: this,
    next: file => {
      if (!file) return;
      this.fileToJsonService.convertMemberFileToJson(file).then(records => {
        this._records.next(records);
        this.setFileName(file.name);
      });
    }
  });

  public primaryClicked(): void {
    combineLatest([this.hasErrors$, this.records$]).once(([hasErrors, records]) => {
      this.activeModal.close(hasErrors ? { discardUpload: true } : { records, continue: true });
    });
  }

  public closeClicked(): void {
    combineLatest([this.hasErrors$, this.records$]).once(([hasErrors, records]) => {
      this.activeModal.close(hasErrors ? { closedWithErrors: true } : { records, continue: false });
    });
  }

  setupBindings(): void {}

  setupViews(): void {}

  protected readonly SecondaryButtonStyleEnum = SecondaryButtonStyleEnum;
}
